import { ref, computed } from '@vue/composition-api'

export function useOtpErrors({
  isOtpComplete = ref(false),
  isInteracting = ref(false),
  otpDigits = ref([]),
} = {}) {
  const apiErrorMessage = ref('')
  const isValid = ref(false)
  const validationHasFailed = ref(false)
  const hasBeenTouched = ref(false)

  function validate() {
    hasBeenTouched.value = true
    const isFormValid = isOtpComplete.value
    isValid.value = isFormValid
    validationHasFailed.value = !isFormValid
    return isFormValid
  }

  function clearAllErrors() {
    apiErrorMessage.value = ''
    validationHasFailed.value = false
  }

  function setApiError(message) {
    hasBeenTouched.value = true
    apiErrorMessage.value = mapErrorMessage(message)
    isValid.value = false
    validationHasFailed.value = true
  }

  // TODO: do mapping based upon status codes
  function mapErrorMessage(message) {
    const errorMap = {
      'Failed to send OTP. Please try again later.': 'Failed to send verification code. Please try again later.',
      'Verification attempts exceeded. Please try again later.': 'Too many attempts. Please try again after some time.',
      'Too many attempts. Please try again later.': 'Too many attempts. Please try again after some time.',
      'Please wait before requesting another OTP.': 'Please wait before requesting another code.',
      'No OTP found for this email.': 'No verification code found. Please request a new code.',
      'OTP has expired.': 'Code expired. Please request a new code.',
      'Invalid OTP code.': 'Incorrect code. Please check your input and try again.',
    }
    return errorMap[message] || message
  }

  const areAllInputsEmpty = computed(() => otpDigits.value && otpDigits.value.length > 0 && otpDigits.value.every(digit => digit === ''))

  const errorMessage = computed(() => {
    if (!hasBeenTouched.value) return ''
    if (apiErrorMessage.value) return apiErrorMessage.value
    if (validationHasFailed.value && !isInteracting.value) {
      return areAllInputsEmpty.value ? 'Please enter the code.' : 'Code must be 6 digits.'
    }
    return ''
  })

  const hasError = computed(() => hasBeenTouched.value && !isInteracting.value && (validationHasFailed.value || apiErrorMessage.value))

  return {
    isValid,
    hasError,
    errorMessage,
    validate,
    clearAllErrors,
    setApiError,
  }
}
